import { fetchData } from './utils';
import { ApiResponse } from './types';

import { CAMPAIGN } from './mediaPlanning';

export interface Touchpoint {
  touchpointFunnel: string;
  TouchpointName: string;
  isMustHave: number;
}

export const getTouchpoints = async (
  division: string,
  brand: string,
  category: string,
  countryISO: string,
  targetGroup: string,
  campaignScenario: string,
  isTVIncluded?: boolean | null
) => {
  return fetchData<ApiResponse<Touchpoint[]>>(`/${CAMPAIGN}/touchpoints`, {
    params: {
      division,
      brand,
      category,
      countryISO,
      targetGroup,
      campaignScenario,
      ...(isTVIncluded != null && { isTVIncluded }),
    },
  });
};
